import { html } from "lit-html";
import { useAjax } from "Services/useAjax";
import { submitTimetablePost } from "./adminCommon";
import { useState } from "Shared/haunted/CustomHooks";

export const useTimetableSection = () => {
	const { ajaxRequest } = useAjax();

	const [TTFrom, setTTFrom] = useState("");
	const [TTTo, setTTTo] = useState("");

	const invalidate = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		await submitTimetablePost({ TTFrom, TTTo, ajaxRequest });
	};

	const buttonTemplate = () => html`
		<button class="bg-n-blue hover:bg-n-red hover:text-white" @click=${invalidate}>Invalidate</button>
	`;

	const htmlTemplate = () => html`
		<section class="mt-6">
			<div class="flex items-center gap-4">
				<input
					class="flex h-10 appearance-none items-center rounded-lg border border-solid border-black px-4"
					placeholder="From"
					value=${TTFrom}
					@input=${(e: InputEvent) => setTTFrom((e.target as HTMLInputElement).value)}
				/>
				<input
					class="flex h-10 appearance-none items-center rounded-lg border border-solid border-black px-4"
					placeholder="To"
					value=${TTTo}
					@input=${(e: InputEvent) => setTTTo((e.target as HTMLInputElement).value)}
				/>
				${buttonTemplate()}
			</div>
		</section>
	`;

	return { htmlTemplate };
};
